import Swiper from 'swiper/dist/js/swiper.min.js'

/**
 * Mock feature implementing most of the stuff on the stack.
 * Due to the 'withResponsive' HOC, foo will only mount on the requested breakpoints.
 *
 * Props:
 * shouldBar(boolean, optional): flag for toggling Bar
 * screens(object, optional): Used by withResponsive. object that can contains a 'min' and a 'max'
 * attribute. The breakpoints are specified in the withResponsive HOC.
 */
export default {
  name: 'swiper-nav-mobile',
  speed: 400,

  componentDidMount () {
    this.btsLevel1 = this.el.querySelectorAll('.header-menu--level1')
    this.contentsLevel2 = this.el.querySelectorAll('.header-menu--level2')
    this.btsBack = this.el.querySelectorAll('.swiper-nav-mobile__heading')
    this.swiperWrapper = this.el.querySelector('.swiper-wrapper')
    this.btClose = document.querySelector('.hamburger')

    setTimeout(() => {
      const that = this
      this.swiper = new Swiper(this.el, {
        direction: 'horizontal',
        speed: this.speed,
        slidesPerView: 1,
        spaceBetween: 0,
        simulateTouch: false,
        shortSwipes: false,
        longSwipes: false,
        allowTouchMove: false,
        autoHeight: true,
        on: {
          slideChangeTransitionEnd: function () {
            if (this.realIndex === 1) {
              that.swiperWrapper.style.height = 'auto'
            }
          },
        },
      })
    }, 200)

    // for (const [i, bt] of this.btsLevel1.entries()) {
    this.btsLevel1.forEach((bt, i) => {
      bt.addEventListener('click', e => {
        if (
          this.contentsLevel2[i] &&
          this.contentsLevel2[i].childElementCount > 0
        ) {
          e.preventDefault()
          for (const c of this.contentsLevel2) {
            c.style.display = 'none'
          }
          this.contentsLevel2[i].style.display = 'block'
          this.swiper.slideTo(1)
        }
      })
    })

    // for (const bt of this.btsBack) {
    this.btsBack.forEach(bt => {
      bt.addEventListener('click', () => {
        this.swiper.slideTo(0)
      })
    })

    this.btClose.addEventListener('click', () => {
      setTimeout(() => {
        this.swiper.slideTo(0)
      }, this.speed)
    })
  },
}
